/**
 * The permission codes the service publishes, mirrored here.
 *
 * These must match `com.loyalty.shared.security.Permissions` exactly. A code
 * that exists only here is worse than useless: the control it hides would be
 * hidden from everyone, because nobody can ever hold a permission the service
 * does not grant. Naming them once, in one file, is what keeps that from
 * happening quietly in a view.
 */
export const P = {
  CUSTOMER_READ: 'CUSTOMER_READ',
  CUSTOMER_CREATE: 'CUSTOMER_CREATE',
  CUSTOMER_UPDATE: 'CUSTOMER_UPDATE',
  CUSTOMER_DELETE: 'CUSTOMER_DELETE',

  SEGMENT_READ: 'SEGMENT_READ',
  SEGMENT_MANAGE: 'SEGMENT_MANAGE',
  SEGMENT_APPLICATION_REVIEW: 'SEGMENT_APPLICATION_REVIEW',
  SEGMENT_MEMBER_REVOKE: 'SEGMENT_MEMBER_REVOKE',

  PROGRAM_READ: 'PROGRAM_READ',
  PROGRAM_MANAGE: 'PROGRAM_MANAGE',

  POINTS_READ: 'POINTS_READ',
  POINTS_EARN: 'POINTS_EARN',
  POINTS_ADJUST: 'POINTS_ADJUST',

  REDEMPTION_READ: 'REDEMPTION_READ',
  REDEMPTION_QUOTE: 'REDEMPTION_QUOTE',
  REDEMPTION_INITIATE: 'REDEMPTION_INITIATE',
  REDEMPTION_CONFIRM: 'REDEMPTION_CONFIRM',
  REDEMPTION_CANCEL: 'REDEMPTION_CANCEL',

  TRANSACTION_READ: 'TRANSACTION_READ',
  TRANSACTION_EXPORT: 'TRANSACTION_EXPORT',

  VOUCHER_READ: 'VOUCHER_READ',
  VOUCHER_MANAGE: 'VOUCHER_MANAGE',
  VOUCHER_REDEEM: 'VOUCHER_REDEEM',

  CASHBACK_READ: 'CASHBACK_READ',
  CASHBACK_MANAGE: 'CASHBACK_MANAGE',

  CAMPAIGN_READ: 'CAMPAIGN_READ',
  CAMPAIGN_EXECUTE: 'CAMPAIGN_EXECUTE',

  SMS_PROVIDER_READ: 'SMS_PROVIDER_READ',
  SMS_PROVIDER_MANAGE: 'SMS_PROVIDER_MANAGE',
  SMS_LOG_READ: 'SMS_LOG_READ',

  NOTIFICATION_READ: 'NOTIFICATION_READ',
  NOTIFICATION_MANAGE: 'NOTIFICATION_MANAGE',

  BULK_IMPORT_READ: 'BULK_IMPORT_READ',
  BULK_IMPORT_EXECUTE: 'BULK_IMPORT_EXECUTE',

  IAM_USER_READ: 'IAM_USER_READ',
  IAM_USER_MANAGE: 'IAM_USER_MANAGE',
  IAM_ROLE_READ: 'IAM_ROLE_READ',
  IAM_ROLE_MANAGE: 'IAM_ROLE_MANAGE',

  REFUND_READ: 'REFUND_READ',
  REFUND_REQUEST: 'REFUND_REQUEST',
  REFUND_APPROVE: 'REFUND_APPROVE',

  COUNTER_USE: 'COUNTER_USE',
  COUNTER_REPORT: 'COUNTER_REPORT',
  COUNTER_ADMIN: 'COUNTER_ADMIN',

  REPORT_READ: 'REPORT_READ',
  REPORT_EXPORT: 'REPORT_EXPORT',

  ANALYTICS_READ: 'ANALYTICS_READ',
} as const

export type PermissionCode = (typeof P)[keyof typeof P]
